// extracted by mini-css-extract-plugin
export var deleteModal = "_r6-0";